import { React, useState, memo, useEffect, useCallback } from "react";
import Burger from "./Burger";
import { NavStyle } from "./headerStyle";
import "../../services/AxiosService";
import "./header.scss";
import { SpinnerCircleMini } from "../../atoms/spinner/Spinner";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import Banner from "./Banner";
import Breadcrumbs from './Breadcrumbs';
import { useLocation } from "react-router-dom";

const Header = () => {
  // const [user] = useLocalStorage("user", "");
  const [user] = useLocalStorage("user", "");
  const [open, setOpen] = useState(localStorage.getItem("openNav"));
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const handleOpen = useCallback(() => {
    open
      ? localStorage.removeItem("openNav")
      : localStorage.setItem("openNav", open);
    setOpen(localStorage.getItem("openNav"));
  }, [open]);

  useEffect(() => {
    if (open !== undefined || open !== null) {
      setLoading(true);
    }
  }, [open]);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      // Verificar si el click se produjo fuera del menú
      if (!event.target.closest('.navHeader')) {
        // Si el menú está abierto, cerrarlo
        if (open) {
          handleOpen();
        }
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [open, handleOpen]);

  return (
    <>
      <div className="barra-sombra">
        <NavStyle className="navHeader">
          <div className="d-flex justify-content-between ">
            {loading ? (
              <>
                <div className="div-logos-header">
                  <div
                    className="div-menu-logo"

                    onClick={() => {
                      window.open(
                        process.env.REACT_APP_URL_PORTAL_EMPLEADO,
                        "_blank"
                      );
                      // navigate('/home')
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                      window.open(
                        process.env.REACT_APP_URL_PORTAL_EMPLEADO,
                        "_blank"
                      );
                      // navigate('/home')
                    }}}
                    title="Portal del Empleado de Extremadura"
                    aria-label="Portal del Empleado de Extremadura. Volver al inicio"
                    tabIndex={0}
                  ></div>
                  {/* <div
                  className="div-menu-control-horario div-menu-logo"
                  onClick={() => {
                    navigate("/home");
                  }}
                ></div> */}
                </div>
              </>
            ) : (
              <>
                <SpinnerCircleMini></SpinnerCircleMini>
              </>
            )}
            <div className="d-flex">
              <div className="d-flex align-content-center">
                <p className="text-center text-third-2 textNombre">
                  {window.location.pathname !== "/" &&
                    window.location.pathname !== "/login" ? (
                    user?.nombreCompleto !== undefined ? (
                      <>
                        {`${user?.nombreCompleto}`}{" "}
                      </>
                    ) : null
                  ) : null}
                </p>
              </div>
              {window.location.pathname !== "/" &&
                window.location.pathname !== "/login" &&
                window.location.pathname !== "/lgn" ? (<>
                  <Burger
                    visible={
                      window.location.pathname !== "/" &&
                      window.location.pathname !== "/login" &&
                      window.location.pathname !== "/lgn"
                    }
                    open={
                      window.location.pathname !== "/" &&
                        window.location.pathname !== "/login" &&
                        window.location.pathname !== "/lgn"
                        ? open
                        : false
                    }
                    handleOpen={handleOpen}
                  />
                </>) : null}

            </div>
          </div>
        </NavStyle>
      </div>
      {window.location.pathname !== "/" &&
        window.location.pathname !== "/login" ? (
        <Banner path={window.location.pathname} />
      ) : null}
      {location.pathname !== "/login" && location.pathname !== "/lgn" ? (<>
        <Breadcrumbs />
      </>) : null}

    </>
  );
};

export default memo(Header);
